import { config, donateData } from "../utils";
const DonateComp = () => {
  return (
    <div className="container bg-light overflow-hidden my-5 px-lg-0">
      <div className="container feature px-lg-0">
        <div className="row g-0 mx-lg-0">
          <div
            className="col-lg-7 feature-text py-5 wow fadeIn"
            data-wow-delay="0.1s"
          >
            <div className="p-lg-1 ps-lg-0">
              <h1 className="text-primary mb-1">
                You too can help sustain {config.appName} programs. How?
              </h1>
              {donateData.map((x, index) => {
                return (
                  <p key={index}>
                    <i className="fa fa-check-circle text-primary me-3"></i>
                    {x}
                  </p>
                );
              })}
            </div>
          </div>
          <div
            className="col-lg-4 mt-5 pe-lg-0 wow fadeIn"
            data-wow-delay="0.5s"
          >
            <div className="position-relative h-100">
              <img
                className="position-absolute img-fluid"
                src="img/donate.png"
                alt={"Donate"}
              />
            </div>
            {/*   {partners.map((x) => {
                  return (
                    <div className="col-lg-4 col-md-6 first">
                      <div className="portfolio-img rounded overflow-hidden">
                        <img className="img-fluid" src={x.img} alt={x.name} />
                      </div>
                    </div>
                  );
                })} */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default DonateComp;
